import { fold, map as emap } from 'fp-ts/lib/Either';
import { useEffect, Dispatch, useState, SetStateAction } from 'react';
import {
  useUserContext,
  getRequest,
  IError,
  IRequestDetails,
  ResponseCSOSHeaders,
  getHeaders,
} from '../common';
import { compose } from 'lodash/fp';

export function usePreviousRequest({ requestType }: { requestType: string }) {
  const [previousRequest, setPrevious] = useState<IRequestDetails>();

  const { user } = useUserContext();

  useEffect(() => {
    compose(emap(handleRequest(setPrevious)), getHeaders)(user);
  }, [user, requestType]);
  return { previousRequest };
}

const handleRequest =
  (setPrevious: Dispatch<SetStateAction<IRequestDetails | undefined>>) =>
  (hR: ResponseCSOSHeaders) =>
    getRequest(hR)
      .then(
        fold<IError, IRequestDetails, void>(
          a => console.error(a), // TODO implement
          setPrevious
        )
      )
      .catch(console.error); // TODO implement
